"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app-wrap app-theme-bg",
    class: {
      'app-wrap--statebrowser-drawopen': _vm.stateBrowserDrawOpen,
      'app-wrap--monospace': _vm.$state.setting('useMonospace'),
      'app-wrap--touch': _vm.$state.ui.is_touch
    },
    attrs: {
      "data-theme": _vm.currentThemeName,
      "data-activebuffer": _vm.buffer ? _vm.buffer.name.toLowerCase() : ''
    },
    on: {
      "click": _vm.emitDocumentClick,
      "!paste": function ($event) {
        return _vm.emitBufferPaste.apply(null, arguments);
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "app-alert-trans"
    }
  }, [_vm.alertMessage ? _c('div', {
    staticClass: "app-alert",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        _vm.alertMessage = '';
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.alertMessage))])]) : _vm._e()]), !_vm.hasStarted || !_vm.fallbackComponent && _vm.networks.length === 0 ? [_c(_vm.startupComponent, {
    tag: "component",
    on: {
      "start": _vm.startUp
    }
  }), _vm.isAutoStarting ? _c('div', {
    staticClass: "app-connecting-screen app-connecting-screen--overlay"
  }, [_vm._m(0)]) : _vm._e()] : [_vm.shouldShowPostConnectLoader ? _c('div', {
    staticClass: "app-connecting-screen"
  }, [_vm._m(1)]) : [_vm.isChannelLoading ? _c('div', {
    staticClass: "app-who-loading",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "app-who-loading-spinner"
  }), _c('span', [_vm._v("Chargement en cours...")])]) : _vm._e(), _c('header', {
    staticClass: "app-global-topbar",
    attrs: {
      "aria-label": _vm.appName
    }
  }, [_c('div', {
    staticClass: "app-global-left"
  }, [_c('button', {
    staticClass: "app-global-burger",
    attrs: {
      "type": "button",
      "title": "Salons et messages privés"
    },
    on: {
      "click": _vm.mobileToggleChannels
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "aria-hidden": "true"
    }
  }, [_c('line', {
    attrs: {
      "x1": "3",
      "y1": "6",
      "x2": "21",
      "y2": "6"
    }
  }), _c('line', {
    attrs: {
      "x1": "3",
      "y1": "12",
      "x2": "21",
      "y2": "12"
    }
  }), _c('line', {
    attrs: {
      "x1": "3",
      "y1": "18",
      "x2": "21",
      "y2": "18"
    }
  })]), _vm.unreadMessages.count > 0 ? _c('span', {
    staticClass: "app-burger-badge",
    class: {
      'app-burger-badge--highlight': _vm.unreadMessages.highlight
    }
  }, [_vm._v(_vm._s(_vm.unreadMessages.count > 999 ? '999+' : _vm.unreadMessages.count))]) : _vm._e()]), _c('span', {
    staticClass: "app-global-channel"
  }, [_vm._v(_vm._s(_vm.topbarTitle))]), _vm.shouldShowTopic ? _c('div', {
    staticClass: "app-global-topic",
    domProps: {
      "innerHTML": _vm._s(_vm.formattedTopic)
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "app-global-right"
  }, [_c('button', {
    staticClass: "app-global-icon app-theme-toggle",
    attrs: {
      "type": "button",
      "title": _vm.colourMode === 'light' ? 'Passer en thème sombre' : 'Passer en thème clair'
    },
    on: {
      "click": _vm.toggleColourMode
    }
  }, [_vm.colourMode !== 'light' ? _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "4"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 2v2"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 20v2"
    }
  }), _c('path', {
    attrs: {
      "d": "m4.93 4.93 1.41 1.41"
    }
  }), _c('path', {
    attrs: {
      "d": "m17.66 17.66 1.41 1.41"
    }
  }), _c('path', {
    attrs: {
      "d": "M2 12h2"
    }
  }), _c('path', {
    attrs: {
      "d": "M20 12h2"
    }
  }), _c('path', {
    attrs: {
      "d": "m6.34 17.66-1.41 1.41"
    }
  }), _c('path', {
    attrs: {
      "d": "m19.07 4.93-1.41 1.41"
    }
  })]) : _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"
    }
  })])]), _vm.buffer && _vm.buffer.isChannel() && _vm.buffer.joined && _vm.network && _vm.network.state === 'connected' ? _c('div', {
    staticClass: "app-global-actions"
  }, [_vm._l(_vm.pluginUiChannelElements, function (plugin) {
    return _c(plugin.component, _vm._b({
      key: plugin.id,
      tag: "component",
      staticClass: "app-header-option",
      attrs: {
        "plugin-props": {
          buffer: _vm.buffer
        },
        "network": _vm.network,
        "buffer": _vm.buffer,
        "sidebar-state": _vm.sidebarState
      }
    }, 'component', plugin.props, false));
  }), _c('button', {
    staticClass: "app-global-icon app-users-btn",
    class: {
      'is-active': _vm.sidebarState.section() === 'nicklist'
    },
    attrs: {
      "type": "button",
      "title": _vm.$t('person', {
        count: _vm.channelUserCount
      })
    },
    on: {
      "click": function ($event) {
        return _vm.toggleNicklistPanel();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('button', {
    staticClass: "app-global-icon",
    class: {
      'is-active': _vm.sidebarState.section() === 'settings'
    },
    attrs: {
      "type": "button",
      "title": _vm.$t('channel_settings')
    },
    on: {
      "click": function ($event) {
        return _vm.toggleSettingsPanel();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2) : _vm._e()])]), _c('state-browser', {
    attrs: {
      "networks": _vm.networks,
      "sidebar-state": _vm.sidebarState
    }
  }), _c('div', {
    staticClass: "app-workspace",
    class: {
      'app-workspace--disconnected': _vm.network && _vm.network.state !== 'connected'
    },
    on: {
      "click": function ($event) {
        _vm.stateBrowserDrawOpen = false;
      }
    }
  }, [_c('div', {
    staticClass: "app-workspace-background"
  }), (!_vm.activeComponent || _vm.isRadioModal) && _vm.network ? [_c('container', {
    attrs: {
      "network": _vm.network,
      "buffer": _vm.buffer,
      "sidebar-state": _vm.sidebarState
    },
    scopedSlots: _vm._u([_vm.mediaviewerOpen ? {
      key: "before",
      fn: function () {
        return [_c('media-viewer', {
          staticClass: "app-main-mediaviewer",
          attrs: {
            "url": _vm.mediaviewerUrl,
            "component": _vm.mediaviewerComponent,
            "component-props": _vm.mediaviewerComponentProps,
            "is-iframe": _vm.mediaviewerIframe
          },
          on: {
            "close": function ($event) {
              return _vm.$state.$emit('mediaviewer.hide', {
                source: 'user'
              });
            }
          }
        })];
      },
      proxy: true
    } : null], null, true)
  }), _vm.buffer.show_input ? _c('control-input', {
    attrs: {
      "network": _vm.network,
      "buffer": _vm.buffer,
      "sidebar-state": _vm.sidebarState
    }
  }) : _vm._e()] : !_vm.activeComponent ? _c(_vm.fallbackComponent, _vm._b({
    tag: "component"
  }, 'component', _vm.fallbackComponentProps, false)) : _vm._e(), _vm.activeComponent ? _c(_vm.activeComponent, _vm._b({
    tag: "component"
  }, 'component', _vm.activeComponentProps, false)) : _vm._e()], 2), _c('nav', {
    staticClass: "app-mobile-nav",
    attrs: {
      "aria-label": "Navigation"
    }
  }, [_c('button', {
    staticClass: "app-mobile-nav-item",
    class: {
      'is-active': _vm.mobileTab === 'salon'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mobileShowChannel
    }
  }, [_c('i', {
    staticClass: "fa fa-comment",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("Salon")])]), _c('button', {
    staticClass: "app-mobile-nav-item",
    class: {
      'is-active': _vm.mobileTab === 'nicklist'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mobileShowNicklist
    }
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("En ligne")])]), _c('button', {
    staticClass: "app-mobile-nav-item",
    class: {
      'is-active': _vm.mobileTab === 'messages'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mobileToggleMessages
    }
  }, [_c('span', {
    staticClass: "app-mobile-nav-iconwrap"
  }, [_c('i', {
    staticClass: "fa fa-comments",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm.unreadPrivateMessages.count > 0 ? _c('span', {
    staticClass: "app-mobile-nav-badge",
    class: {
      'app-mobile-nav-badge--highlight': _vm.unreadPrivateMessages.highlight
    }
  }, [_vm._v(_vm._s(_vm.unreadPrivateMessages.count > 99 ? '99+' : _vm.unreadPrivateMessages.count))]) : _vm._e()]), _c('span', [_vm._v("Messages")])])])]], _vm.shouldShowCgu ? _c('CguModal', {
    on: {
      "accept": _vm.acceptCgu
    }
  }) : _vm._e(), _c('AvatarCommon')], 2);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app-connecting-card"
  }, [_c('div', {
    staticClass: "app-connecting-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('div', {
    staticClass: "app-connecting-text"
  }, [_vm._v("Connexion en cours...")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app-connecting-card"
  }, [_c('div', {
    staticClass: "app-connecting-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('div', {
    staticClass: "app-connecting-text"
  }, [_vm._v("Connexion en cours...")])]);
}];